import { createBrowserRouter, Route, Routes } from 'react-router-dom';

import ErrorPage from './error.page';
import HomePage from './home.page';
import WalkinPage from './walkin.page';
import CheckedInPage from './checked-in.page';
import ChatPage from './chat.page';
import UserInfoPage from './user-info.page';
// import ReadyPage from './ready.page';
import AddClient from './add-client.page';
import useScreenTracking from '../hooks/useScreenTracking';



export const SCREENS = {
  HOME: { path: '/', name: 'Home Page' },
  ADD_CLIENT: { path: '/add-client/:spId', name: 'Add Client' },
  USER_INFO: { path: '/:companyId/user-info', name: 'User Info' },
  CHECKED_IN: { path: '/:companyId/checked-in', name: 'Checked In' },
  // READY: { path: '/:companyId/ready', name: 'Ready' },
  CHAT: { path: '/:companyId/chat', name: 'Chat' },
  WALKIN: { path: '/:companyId', name: 'Walkin Page' },
} as const;

export type ScreenPaths = typeof SCREENS[keyof typeof SCREENS]['path'];

export const Router = () => {
  useScreenTracking();
  return (
    <Routes>
      <Route path={SCREENS.HOME.path} element={<HomePage />} />
      <Route path={SCREENS.ADD_CLIENT.path} element={<AddClient />} />
      <Route path={SCREENS.USER_INFO.path} element={<UserInfoPage />} />
      <Route path={SCREENS.CHECKED_IN.path} element={<CheckedInPage />} />
      {/* <Route path={SCREENS.READY.path} element={<ReadyPage />} /> */}
      <Route path={SCREENS.CHAT.path} element={<ChatPage />} />
      <Route path={SCREENS.WALKIN.path} element={<WalkinPage />} />
      
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
}
